import { createAction } from 'redux-act';

export const tourShow = createAction('show tour start');

export const allowTour = (showTourValue) => async (dispatch) => {
  setTimeout(() => {
    dispatch(tourShow(showTourValue));
  }, 800);
};
